import { useState } from "react";
import { motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import EtContactConversation from "@/components/contact/EtContactConversation";

 const EtModalContactConversation = ({ open, onClose }) => {
  // First Created - 10 Oct 2025
  // Author - Atul Pandey
  // Updated - 25 Nov 2025 - ctaSource refinements


  if (!open) return null;

  // 25 Nov 2025
  const source = open?.source;

  return (
    <div role="dialog" aria-modal="true" className="fixed inset-0 z-50 flex items-center justify-center">
      {/* <div className="absolute inset-0 bg-black/60" onClick={onClose} /> */}
      <div className="absolute inset-0 bg-black/60" />
      <motion.div
        className="relative w-full max-w-2xl mx-auto rounded-2xl bg-black/85 border border-white/10 shadow-xl overflow-hidden"
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
      >
        <button className="absolute top-3 right-3 p-2 rounded-lg bg-white/5 hover:bg-white/10" onClick={onClose}>
          <XMarkIcon className="h-6 w-6 text-gray-300" />
        </button>
        {/* 25 Nov 2025 - Added ctaSource to the props */}
        <EtContactConversation onDone={onClose} ctaSource={source} /> 
      </motion.div>
    </div>
  );
}

export default EtModalContactConversation
